//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Address
import com.tixforgigs.apax.models.BankAccount
import com.tixforgigs.apax.models.CompanyData
import com.tixforgigs.apax.models.Roles
import com.tixforgigs.apax.models.Scopes
import com.tixforgigs.apax.models.UserData

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The user model
* 
* @param profileId the profile id
* @param userData 
* @param addresses The addresses of the user
* @param bankAccounts The bank accounts of the user
* @param companyData 
* @param grantedScopes The granted scopes of the user
* @param roles The roles of the user
*/
@Serializable

data class UserProfile (


      /* the profile id */
    @SerialName(value = "profileId") @Required val profileId: kotlin.String,


      @SerialName(value = "userData") @Required val userData: UserData,


      /* The addresses of the user */
    @SerialName(value = "addresses") val addresses: kotlin.collections.List<Address>? = null,


      /* The bank accounts of the user */
    @SerialName(value = "bankAccounts") val bankAccounts: kotlin.collections.List<BankAccount>? = null,


      @SerialName(value = "companyData") val companyData: CompanyData? = null,


      /* The granted scopes of the user */
    @SerialName(value = "grantedScopes") val grantedScopes: kotlin.collections.List<Scopes>? = null,


      /* The roles of the user */
    @SerialName(value = "roles") val roles: kotlin.collections.List<Roles>? = null


) {




  }

